import React from 'react';
import { Icon } from './Icon.js';
export const IconDeskLamp = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M11.4167 21H10.25L5 13.5765L10.5443 8.03223", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M15 21H5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M12.7586 2.64827L8.97927 6.42759L12.2758 9.72414L12.2758 13.0207L13.9241 14.669L21 7.5931L19.3517 5.94482L16.0551 5.94482L12.7586 2.64827Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconDeskLamp.js.map